import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import Teilnahmebedingungen from "@/pages/Teilnahmebedingungen";
import Datenschutz from "@/pages/Datenschutz";
import Impressum from "@/pages/Impressum";
import AdminPage from "@/pages/AdminPage";
import { RoutePageViews } from "@/lib/meta";

function App() {
  return (
    <div className="App bg-paper text-ink">
      <BrowserRouter>
        <RoutePageViews />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/teilnahmebedingungen" element={<Teilnahmebedingungen />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-center" />
    </div>
  );
}

export default App;
